(function () {
  'use strict';

  window.CHATBOT_PAGE_MODE = true;
  document.body.classList.add('chatbot-page-mode');

  function initializeChatbot() {
    var root = document.querySelector('[data-chatbot-page]');
    if (!root) return;

    document.body.classList.add('chatbot-page-mode');
    window.CHATBOT_PAGE_MODE = true;

    window.SHOPIFY_CUSTOMER_ID = root.dataset.customerId || null;
    window.SHOPIFY_CUSTOMER_EMAIL = root.dataset.customerEmail || null;
    window.SHOPIFY_CUSTOMER_NAME = root.dataset.customerName || null;
    window.CHATBOT_IS_AUTHENTICATED = root.dataset.isAuthenticated === 'true';
    window.CHATBOT_AUTH_REQUIRED_URL = root.dataset.authUrl || '/account/login';

    window.CODESKIN_LOGO_URL = root.dataset.logoUrl || '';
    window.WELCOME_VIDEO_URL = root.dataset.welcomeVideoUrl || '';
    window.WELCOME_VIDEO_CAPTIONS_URL = root.dataset.welcomeCaptionsUrl || '';
    window.FACESCAN_VIDEO_URL = root.dataset.facescanVideoUrl || '';
    window.RESULTS_VIDEO_URL = root.dataset.resultsVideoUrl || '';
    window.PRODUCTS_VIDEO_URL = root.dataset.productsVideoUrl || '';
    window.PRODUCTS_VIDEO_CAPTIONS_URL = root.dataset.productsCaptionsUrl || '';

    // Dedicated page mode should not keep cart drawer overlays open.
    document.body.classList.remove('overflow-hidden');
    document.querySelectorAll('[cart-drawer-section], [data-drawer="cart-drawer"]').forEach(function (drawer) {
      drawer.classList.remove('show', 'shadow');
      drawer.style.display = 'none';
    });

    // Hard guard: on chatbot page, header icons must navigate (no drawer popups).
    document.addEventListener('click', function (event) {
      var iconLink = event.target.closest('.header--icon-item a.header--icon-link-text, .header--icon-item a.header--icon-link');
      if (!iconLink) return;
      var href = iconLink.getAttribute('href');
      if (!href) return;
      // Header cart icon on chatbot page must always navigate to cart page.
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = href;
    }, true);

    // Force dedicated page layout (not popup/card widget behavior).
    var applyDedicatedLayout = function () {
      var box = document.getElementById('chatbot-box');
      if (!box) return;
      box.classList.add('open');
      box.classList.add('expanded');
      box.style.display = 'flex';
      box.style.width = '100%';
      box.style.maxWidth = 'none';
      box.style.left = '0';
      box.style.right = '0';
      box.style.bottom = '0';
      box.style.top = '0';
    };

    // Initial pass + delayed passes because chatbot DOM mounts asynchronously.
    applyDedicatedLayout();
    setTimeout(applyDedicatedLayout, 100);
    setTimeout(applyDedicatedLayout, 400);
    setTimeout(applyDedicatedLayout, 900);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeChatbot();
  });
})();
